import styled from "styled-components";

const StyledRates = styled.section`
  &
    .d-none.d-sm-none.d-md-none.d-lg-flex.align-items-center.justify-content-center.pb-2.pb-sm-2.pb-md-0.mb-4.col-lg-1.col-sm-12 {
    width: 0 !important;
    margin: 0 !important;
    padding: 1px !important;
  }
  & #phoneLotext{
     text-align: center;
  color: #00C2FF;
  text-decoration: none;
  font-weight: 600;
  margin-top: -1.75rem;
    }
  & #phoneLotext a{
    color: #00C2FF;
  text-decoration: none;
    }
   & #phoneLotext a:hover{
    color: #00C2FF;
  text-decoration: underline;
    }
    & #loRateTitle{
    color:#fff;
    text-align:center;
    margin-top: 4rem;
    }
    & #refinanceLoTitle{
    color:#fff;
    font-size: 17px;
    text-align:center;
    margin-bottom: -3.5rem;
    }
    #lo-rate-component{
    min-height: 12rem;
    }

    #todayRatesTitle h1{
    display: none;
    }
  &
    .btnApplyNow.btn.btn-primary:is(:hover, :active, :focus)
    :where(div h4.textBlue.poppins-black, div
      h4.textBlue.poppins-black
      + h4, div h2.reducefontSize strong, div h4.textBlue.poppins-med.pt-0) {
    color: #ffffff !important;
  }
  & div h4.textBlue.poppins-black,
  & div h4.textBlue.poppins-black + h4,
  & div h2.reducefontSize strong {
    color: #083F88;
  }
  & .col-lg-12 .cyanButton.btn.btn-primary {
    // margin-bottom:2rem;
    margin-top: 1rem;
    max-width: 100%;
    margin-inline: auto;
  }
  & #lo-rate-component .col-sm-12.text-center span > span {
    background: #ffffff;
    color: #ffffff;
    margin-top: 4rem !important;
  }
  & > .col-sm-12.text-center > .pt-2 > strong {
    color: #ffffff;
    margin-bottom: 4rem !important;
  }
  & #lo-rate-component .col-sm-12.text-center > .pt-2 > strong {
    color: #fff !important;
    margin-bottom: 4rem !important;
    font-size: 20px !important;
}
  & > div {
    padding-block: 2rem;
    background: none;
  }
  & .overlay .form-check-label {
    border-radius: 50%;
  }
  & .multi-step :not(th h4, th h5, th h2):where(h4, h2, h5) {
    color: #ffffff;
  }
  & #todayRatesTitle h1 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 24.7857px;
    line-height: 37px;
    color: #fff !important;
  }
  & #home-products-tabs,
  & .justify-content-center.m-auto.nav.nav-tabs {
    border-bottom-color: #fff;
  }
  & button.nav-link {
    color: #00AAE4 !important;
    padding: 4px 16px 0px 16px;
    border-radius: 15px 15px 0px 0px;
    margin: 0px 2px;
  }
  & button.nav-link:is(:hover, :active, :focus) {
    background: transparent;
    color: #fff;
    border-radius: 15px 15px 0px 0px;
    border-bottom: none;
    border-color: #fff;
  }
  & .nav-tabs button.nav-link.active {
    background: transparent !important;
    color: #fff !important;
    border-bottom: none;
    border-radius: 15px 15px 0px 0px;
    z-index: 10;
    transform: translateY(1px);
    border-color: #fff;
  }
  & .btnApplyNow {
    width: 100%;
  }
  & .btnApplyNow:is(:hover, :active, :focus) {
    background-color: #083F88 !important;
  }
  & .btnApplyNow:is(:hover, :focus, :active) :where(h4, h2) {
    color: #ffffff !important;
  }
  & .btnApplyNow h4:first-of-type {
    font-family: "Poppins";
    font-style: normal;
    font-weight: bold;
    font-size: 22.9107px;
    line-height: 34px;
    text-align: center;
    border-bottom: 1px solid #d9d9d9;
    color: #00AAE4;
    padding: 0.35rem 0;
  }
  & .btnApplyNow h2,
  & .btnApplyNow h2.re {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 22px !important;
    line-height: 30px;
    text-align: center;
    color: #931668;
  }
  & .textBlue.poppins-med.pt-0,
  & .fontSizeRateAprText {
    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: bold !important;
    font-size: 16.6101px !important;
    line-height: 20px !important;
    text-align: center !important;
    color: #083f88 !important;
    margin-block: 1rem;
  }
  & .btnApplyNow h3 {
    border: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6.56487px;
    gap: 6.56px;
    background: #083F88;
    border-radius: 5.90838px;
    color: #ffffff;
  }
  & .btnApplyNow:is(:hover, :active, :focus) h3 {
    background: #ffffff;
    color: #083F88 !important;
  }
  & .cyanButton {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 10px;
    gap: 10px;
    background: #00aae4;
    border-radius: 9px;
    width: 100%;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 22.8989px;
    line-height: 30px;
    text-align: center;
    color: #ffffff;
    margin-top: 2rem !important;
  }
  & .cyanButton:is(:hover, :active, :focus) {
    background: #ffffff;
    color: #00aae4;
  }
  & .mainBody {
    margin: 0.25rem 0;
  }
  & .mainBody h6 {
    color: #ffffff;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }
  & .noClosingCost {
    color: #ffffff;
  }
  & .backToHome,
  & #next-button,
  & #prev-button {
    color: #ffffff !important;
    border-color: #ffffff;
    background: #00C2FF !important;
  }
  & .col-lg-2 h4 {
    font-size: 18px;
  }

  @media only screen and (min-width: 992px) and (max-width:1200px) {
    & .btnApplyNow h2,
  & .btnApplyNow h2.re {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 18px !important;
    line-height: 25px;
    text-align: center;
  }
    & .cyanButton {
    padding: 10px 10px;
    gap: 10px;
    font-size: 18px;
    line-height: 25px;
  }
  }

  @media only screen and (min-width: 768px) and (max-width:991.8px) {
  & .btnApplyNow {
    width: 90%;
  }
  & .cyanButton{
  line-height:20px;
    }
   & #loRateTitle{
    color:#fff;
    text-align:center;
    margin-top: 4rem;
    }
}

 @media only screen and (max-width:991.8px) {
   & #loRateTitle{
    margin-top: 2rem;
    }
     & #phoneLotext{
  margin-top: 0rem;
    }
}

  @media only screen and (min-width: 992px) {
    & .backToHome {
      margin-right: 0;
      margin-left: 1rem;
    }
    & .col-lg-12 .cyanButton.btn.btn-primary {
      margin-bottom: 2rem;
      min-width: 15rem;
      max-width: 30rem;
      margin-inline: auto;
    }
  }
`;
export default StyledRates;